(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const isMobileTabs = () => mq.matches;

    const ensureInitialOrder = (track) => {
        if (!track || track._initial) return;
        track._initial = Array.from(track.children);
    };

    const restoreDesktopOrder = (track) => {
        if (!track || !track._initial) return;
        track._initial.forEach(el => track.appendChild(el));
    };

    const scrollActiveLeft = (track, pill) => {
        if (!track) return;
        const active = pill || track.querySelector('.latest__pill.is-active');
        if (!active) return;

        const trackRect = track.getBoundingClientRect();
        const itemRect = active.getBoundingClientRect();

        const delta = itemRect.left - trackRect.left;
        const extraPadding = 24;

        const targetScroll = track.scrollLeft + delta - extraPadding;

        track.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
    };

    const applyLayout = () => {
        document.querySelectorAll('.js-latest .latest__tabs-inner').forEach(track => {
            ensureInitialOrder(track);
            if (isMobileTabs()) {
                scrollActiveLeft(track);
            } else {
                restoreDesktopOrder(track);
            }
        });
    };

    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.latest__pill');
        if (!btn) return;

        const root = btn.closest('.js-latest');
        if (!root) return;

        const slug = btn.dataset.cat;
        const track = root.querySelector('.latest__tabs-inner');
        ensureInitialOrder(track);

        root.querySelectorAll('.latest__pill')
            .forEach(b => b.classList.toggle('is-active', b === btn));

        root.querySelectorAll('.latest__pane')
            .forEach(p => p.classList.toggle('is-active', p.dataset.cat === slug));

        if (typeof window.initEmbla === 'function') {
            const pane = root.querySelector(`.latest__pane[data-cat="${slug}"]`);
            if (pane) window.initEmbla(pane);
        }

        if (isMobileTabs() && track) {
            scrollActiveLeft(track, btn);
        } else if (!isMobileTabs()) {
            restoreDesktopOrder(track);
        }
    });

    if (mq.addEventListener) mq.addEventListener('change', applyLayout);
    else mq.addListener(applyLayout);

    window.addEventListener('resize', applyLayout);
    window.addEventListener('orientationchange', applyLayout);
    document.addEventListener('DOMContentLoaded', applyLayout);
})();
